const SkipToContent = () => {
  return (
    <a
      href="#main-content"
      className="skip-to-content"
      style={{
        position: 'absolute',
        left: '-999px',
        width: '1px',
        height: '1px',
        top: 'auto',
        overflow: 'hidden'
      }}
      onFocus={(e) => {
        e.currentTarget.style.left = '0'
        e.currentTarget.style.width = 'auto'
        e.currentTarget.style.height = 'auto'
        e.currentTarget.style.padding = '10px'
        e.currentTarget.style.zIndex = '9999'
        e.currentTarget.style.background = '#fff'
      }}
      onBlur={(e) => {
        e.currentTarget.style.left = '-999px'
        e.currentTarget.style.width = '1px'
        e.currentTarget.style.height = '1px'
      }}
    >
      Skip to main content
    </a>
  )
}

export default SkipToContent
